import * as Scrivito from "scrivito";
import cx from "classnames";
import React, { useCallback, useState } from "react";
import { Icon } from "components/Icon/Icon";
import { useTranslate } from "hooks";
import s from "./LeftSidebar.module.scss";

const firstToggleButtonId = `left-sidebar-toggle-first`;
const secondToggleButtonId = `left-sidebar-toggle-second`;

export const SidebarToggle = Scrivito.connect(
  ({
    setIsOpened,
    isOpened,
    isFirstSidebar,
    text,
    onLeft = false,
    color = "primary",
    isRightSidebarToggle,
  }) => {
    const translate = useTranslate();

    const [offsetHeight, setOffsetHeight] = useState(0);

    const handleToggle = () => {
      setIsOpened(!isOpened);
      handleButtonPosition(!isOpened);
    };

    const handleButtonPosition = useCallback(
      (isSidebarOpened) => {
        if (!isFirstSidebar && !isSidebarOpened && !isRightSidebarToggle) {
          setOffsetHeight(
            document.getElementById(firstToggleButtonId).offsetHeight,
          );
        } else {
          setOffsetHeight(0);
        }
      },
      [isFirstSidebar, isRightSidebarToggle],
    );

    return (
      <div
        className={cx(s.toggleBtnContainer, {
          [s.toggleBtnContainerLeft]: onLeft,
          [s.toggleBtnContainerRight]: !onLeft,
          "bg-blue-300": color === "primary",
          "bg-gray-700": color === "secondary",
        })}
      >
        <div
          className={cx(
            "position-absolute d-flex px-2 py-3 text-white cursor-pointer gap-1",
            s.toggleBtn,
            {
              [s.toggleBtnLeft]: onLeft,
              [s.toggleBtnRight]: !onLeft,
              "bg-blue-300": color === "primary",
              "bg-gray-700": color === "secondary",
            },
          )}
          style={{ top: offsetHeight, transition: "top 0.4s ease" }}
          id={isFirstSidebar ? firstToggleButtonId : secondToggleButtonId}
          onClick={handleToggle}
        >
          <Icon
            prefix="trox"
            iconName={
              isRightSidebarToggle === isOpened
                ? "chevron-right-regular"
                : "chevron-left-regular"
            }
          />
          <div className={cx("fw-semibold user-select-none", s.toggleBtnText)}>
            {translate(text)}
          </div>
        </div>
      </div>
    );
  },
);
